import { useEffect, useRef } from 'react';

import { resetUpsellSession } from '@/features/pricing';

import { CLIENT_STORAGE_QUERY_KEYS, resetClientStorageWriteErrors } from '@/entities/clientStorage';
import { useCognitoCheckUser } from '@/entities/user/currentUser';
import { clearStartScreenShown } from '@/entities/user/trialVariant';

import { queryClient } from '@/shared/config';

export const AuthLostWatcher = () => {
  const { data } = useCognitoCheckUser({ enabled: false });
  const isAuthenticated = Boolean(data?.isAuthorized);
  const wasAuthenticated = useRef(isAuthenticated);

  useEffect(() => {
    if (wasAuthenticated.current && !isAuthenticated) {
      clearStartScreenShown();
      resetUpsellSession();
      resetClientStorageWriteErrors();
      queryClient.removeQueries({ queryKey: CLIENT_STORAGE_QUERY_KEYS.all });
    }
    wasAuthenticated.current = isAuthenticated;
  }, [isAuthenticated]);

  return null;
};
